import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  {
    label: '',
    subLabel: '',
    field: 'WLPostLabPage1',
    type: 'info',
    answer: {
      type: 'list',
      items: [
        {
          label:
            'Do you have any PERSONAL history of heart disease, kidney/liver disease or thyroid cancer?',
          type: 'single_select',
          options: [
            {
              key: 'PERSONALhistoryYes',
              value: 'Yes',
              answer: {
                type: 'list',
                items: [
                  {
                    type: 'text',
                    name: 'PERSONALhistory',
                    placeholder: 'Please Elaborate'
                  }
                ]
              }
            },
            { key: 'PERSONALhistoryNo', value: 'No' }
          ]
        },
        {
          label: 'Do you have any FAMILY history of thyroid cancer?',
          type: 'single_select',
          options: [
            {
              key: 'FAMILYhistoryYes',
              value: 'Yes',
              answer: {
                type: 'list',
                items: [
                  {
                    type: 'text',
                    name: 'FAMILYhistory',
                    placeholder: 'Please Elaborate'
                  }
                ]
              }
            },
            { key: 'FAMILYhistoryNo', value: 'No' }
          ]
        },
        {
          label: 'Do you take any antidepressants or anti-anxiety medications?',
          type: 'single_select',
          options: [
            {
              key: 'antidepressantsYes',
              value: 'Yes',
              answer: {
                type: 'list',
                items: [
                  {
                    type: 'text',
                    name: 'antidepressants',
                    placeholder: 'Please Elaborate Which Medications'
                  }
                ]
              }
            },
            { key: 'antidepressantsNo', value: 'No' }
          ]
        },
        {
          label: 'Have you ever experienced anorexia or bulimia?',
          type: 'single_select',
          options: [
            {
              key: 'anorexiaYes',
              value: 'Yes',
              answer: {
                type: 'list',
                items: [
                  {
                    type: 'text',
                    name: 'anorexia',
                    placeholder: 'Please Elaborate'
                  }
                ]
              }
            },
            { key: 'anorexiaNo', value: 'No' }
          ]
        },
        {
          label: 'Do you have a fear of needles?',
          type: 'single_select',
          options: [
            { key: 'fearOfNeedlesYes', value: 'Yes' },
            { key: 'fearOfNeedlesNo', value: 'No' }
          ]
        }
      ]
    }
  },

  {
    label: 'What is your current: ',
    type: 'info',
    field: 'WLPostLabPage2',
    answer: {
      type: 'list',
      items: [
        {
          label: 'Height',
          type: 'text',
          name: 'WLPostHeight',
          rows: 1
        },
        {
          label: 'Weight',
          type: 'text',
          name: 'WLPostWeight',
          rows: 1
        },
        {
          label: 'How much weight are you wanting to lose?',
          level: 'top',
          type: 'text',
          name: 'WLPostWeightToLose',
          rows: 1
        },
        {
          label:
            'If you were to pick 1 area of your life that you believe to be contributing to your weight would it be:',
          type: 'single_select',
          options: [
            {
              key: 'portionControl',
              value: 'A. Portion control and/or insulin resistance'
            },
            {
              key: 'emotionalEating',
              value:
                'B. Emotional eating/ binge eating (this is more significant than comfort eating or snacking due to stress. This is more of a pathological need for food to help with negative emotions.)'
            }
          ]
        },
        {
          label: 'Any additional questions or concerns:',
          level: 'top',
          type: 'text',
          name: 'WLPostAdditionalInfo',
          rows: 3
        },
        {
          field: 'WLPostAcknowledgement',
          label:
            'I confirm that the above  medical information is complete, true and correct to the best of my knowledge and belief.',
          type: 'select',
          answer: {
            type: 'single_select',
            options: [{ key: 'acneAcknowledgement', value: 'I Agree' }]
          }
        }
      ]
    }
  }
];
export default questionsModels;
